import { type ChatMessage, ChatCustomBlockTypes } from "@do/shared-types";
import axios, { AxiosError } from "axios";

type TFn = (key: string) => string;

export function isNetworkError(error: unknown) {
  return (
    axios.isAxiosError(error) &&
    (error.code === AxiosError.ERR_NETWORK || error.code === AxiosError.ECONNABORTED)
  );
}

export function getGenericErrorMessage(t: TFn): ChatMessage {
  return {
    blocks: [
      {
        type: ChatCustomBlockTypes.text,
        text: t("genericError"),
        metadata: [
          {
            error: true,
          },
        ],
      },
    ],
  };
}

export function getNetworkErrorMessage(t: TFn): ChatMessage {
  return {
    blocks: [
      {
        type: ChatCustomBlockTypes.text,
        text: t("networkError"),
        metadata: [
          {
            error: true,
          },
        ],
      },
    ],
  };
}

export function getOutOfCreditsErrorMessage(t: TFn): ChatMessage {
  return {
    blocks: [
      {
        type: ChatCustomBlockTypes.text,
        text: t("disabledChatbotError"),
        metadata: [
          {
            error: true,
          },
        ],
      },
    ],
  };
}

export function getMessageForError(t: TFn, error: unknown): ChatMessage {
  return isNetworkError(error) ? getNetworkErrorMessage(t) : getGenericErrorMessage(t);
}
